<div class="card">
  <div class="card-header bp-card-header">
    <i class="far fa-calendar-alt fa-widget-icon"></i>
    <p class="font-weight-light bp-text">Recent Water Usage</p>
  </div>
  <div class="card-body usage-content">
    <div class="row water-usage-text">
      <dx-chart id="chart"
                [dataSource]="dataSource"
                palette="Harmony Light"
                [valueAxis]="[{
                    name: 'GPH',
                    position: 'right',
                    showZero: true,
                    tickInterval: 20,
                    valueMarginsEnabled: false,
                     label: {
                        customizeText: customizeGallonsLabelText
                    },
                    title: consumptionType
                }]">
        <dxo-common-series-settings argumentField="date">
          <dxo-border [visible]="true"
                      [width]="2"
                      [right]="true"
                      [left]="true"></dxo-border>
        </dxo-common-series-settings>
        <dxi-series axis="GPH"
                    valueField="GPH"
                    name="Usage ({{consumptionType}})"
                    type="bar"
                    color="#3F8F8B">
        </dxi-series>
        <dxo-argument-axis>
          <dxo-label>
            <dxo-format type="shortDate"></dxo-format>
          </dxo-label>
        </dxo-argument-axis>
        <dxo-legend verticalAlignment="bottom"
                    horizontalAlignment="center"
                    [visible]="true">
        </dxo-legend>
        <dxo-tooltip *ngIf="consumptionType" [enabled]="true"
                     [customizeTooltip]="customizeTooltip">
        </dxo-tooltip>
      </dx-chart>
    </div>
  </div>
  <footer class="blockquote-footer water-usage-footer">
    <div class="row">
      <div class="col-sm-6">
        <div>
          <h4><a class="bp-link-blue">Manage Usage Alerts</a></h4>
        </div>
      </div>
      <div class="col-sm-6">
        <div>
          <h4><a class="bp-link-red float-right" routerLink="/Billing/Usage">View More<i class="fas fa-chevron-right view-more-arrow"></i></a></h4>
        </div>
      </div>
    </div>
  </footer>
</div>



// WEBPACK FOOTER //
// ./src/app/power-usage/power-usage.component.html